import { brandValues } from '@/mocks/brand';
import useScrollAnimation from '@/hooks/useScrollAnimation';

export default function PhilosophySection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.08 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-primary-900 overflow-hidden py-20 md:py-0"
    >
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, oklch(0.72 0.15 85) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full">
        <div
          className={`max-w-[720px] w-full transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-xs text-background-300/60 uppercase tracking-widest mb-4">
            品牌資訊
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight mb-4">
            關於沐燁文化
          </h2>
          <p className="text-background-200/70 text-sm md:text-base leading-relaxed max-w-[560px] mx-auto mb-12">
            沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。以下為品牌相關資訊與查詢入口。
          </p>
        </div>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-[1080px] w-full transition-all duration-700 ease-out delay-150 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {brandValues.map((value) => (
            <div
              key={value.id}
              className="p-6 md:p-8 bg-primary-800/50 border border-primary-700/40 rounded-xl"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-400 mb-5">
                <i className={`${value.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-background-200/60 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}